import { OccupancyIndicator } from '@cmp-src/data-display/OccupancyIndicator/OccupancyIndicator';
import { Button } from '@v2/components/ui/button';
import {
  AgendaCardLayout,
  AgendaCardLayoutProps,
  pxRainbow
} from './AgendaCardLayout';
import { AgendaCardButton } from './AgendaCardLayout';
import { Office } from '@gettactic/api';
import { cn } from '@gettactic/helpers';

const buttonText = 'Make reservation';

export const ReservationCard = ({
  office,
  layoutProps,
  isInOffice = true,
  onReservationClick,
  disabled = false,
  isPastDate = false
}: {
  office?: Office;
  layoutProps?: AgendaCardLayoutProps;
  isInOffice?: boolean;
  onReservationClick: () => void;
  disabled?: boolean;
  isPastDate?: boolean;
}) => {
  const openSpaces = office?.total_open_desks || 0;
  const totalSpaces = office?.total_desks || 0;
  const checkIn = () => {
    onReservationClick();
  };
  if (!isInOffice) {
    return isPastDate ? (
      <div
        className={cn(
          'flex w-full items-center justify-center rounded-md border border-neutral-200 bg-neutral-100 p-3',
          pxRainbow
        )}
      >
        <p className="text-muted-foreground text-sm italic">
          No reservations for this date
        </p>
      </div>
    ) : (
      <Button
        onClick={checkIn}
        variant={'secondaryDashboard'}
        className={cn('w-full', pxRainbow)}
        disabled={disabled}
      >
        {buttonText}
      </Button>
    );
  }

  return (
    <AgendaCardLayout
      topLeft={<div className="flex items-center">No reservations</div>}
      bottomLeft={
        <div className="flex flex-row gap-2 text-overlay text-xs">
          {openSpaces > 0 ? (
            <>
              <OccupancyIndicator
                occupiedSpaces={openSpaces}
                totalSpaces={totalSpaces}
                displaySpacesCount={false}
              />
              <div>
                {openSpaces}/{totalSpaces} desks available
              </div>
            </>
          ) : (
            'No desks'
          )}
        </div>
      }
      button={
        isPastDate ? null : (
          <AgendaCardButton
            variant={'secondaryDashboard'}
            onClick={() => onReservationClick()}
          >
            {buttonText}
          </AgendaCardButton>
        )
      }
      {...layoutProps}
    />
  );
};
